export const CleaningSpecification = {
    MEDIA_TYPES : {
        PDF : 1,
        AUDIO : 2,
        VIDEO : 3
    }
}